module Environments {
    module.directive("agentGroupsList", function () {
        return {
            templateUrl: "AgentGroupsListTemplate"
        };
    });
}